<template>
  <div class="subcontent">
    <div class="subbanner" :style="{ backgroundImage: 'url(' + pageContent.topbanner + ')' }">
      <div class="container">
        <h1 class="title">{{ pageContent.bigadtext }}</h1>
        <span>{{ pageContent.smalladtext }}</span>
      </div>
    </div>
    <div class="mainwrap">
      <div class="container">
        <div class="submain">
          <div class="titleA"><strong>{{ pageContent.title }}</strong></div>
          <div class="textCenter"><img src="../assets/about1.png" /></div>
          <div v-if="pageContent" v-html="pageContent.content"></div>
          <div v-else>
            <p>页面暂无内容</p>
          </div>
          <div class="titleA"><strong>仪器设备展示</strong></div>
          <div class="pics">
            <ul>
              <li>
                <div><img src="../assets/instrument/01.jpg" /></div>
                <div>理化实验室</div>
              </li>
              <li>
                <div><img src="../assets/instrument/02.jpg" /></div>
                <div>万能试验机</div>
              </li>
              <li>
                <div><img src="../assets/instrument/03.jpg" /></div>
                <div>气相色谱仪</div>
              </li>
              <li>
                <div><img src="../assets/instrument/04.jpg" /></div>
                <div>二次元影像测量仪</div>
              </li>
              <li>
                <div><img src="../assets/instrument/05.jpg" /></div>
                <div>恒温恒湿试验箱</div>
              </li>
              <li>
                <div><img src="../assets/instrument/06.jpg" /></div>
                <div>反渗透纯化水机组</div>
              </li>
              <li>
                <div><img src="../assets/instrument/07.jpg" /></div>
                <div>超声波清洗机</div>
              </li>
              <li>
                <div><img src="../assets/instrument/08.jpg" /></div>
                <div>超声波焊接机</div>
              </li>
              <li>
                <div><img src="../assets/instrument/09.jpg" /></div>
                <div>热合包装机</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pageApi } from '@/api'

export default {
  name: 'About',
  data() {
    return {
      pageContent: ''
    }
  },
  mounted() {
    // 使用固定的ID查询，例如ID为1的页面
    this.fetchAboutPage(1)
  },
  methods: {
    async fetchAboutPage(pageId) {
      try {
        const { data } = await pageApi.getPageByParams({
          id: pageId
        })

        this.pageContent = data
      } catch (error) {
        console.error('获取关于页面失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.subcontent {
  font-size: 16px;
  line-height: 1.8;


  .pics {
    width: 960px;
    margin: 0 auto;

    ul {
      margin: 0 -20px;
      padding: 0;

      li {
        width: 33.33%;
        padding: 0 20px;
        margin-bottom: 20px;
        text-align: center;
        display: inline-block;
        box-sizing: border-box;

        img {
          width: 100%;
          max-width: 100%;
        }
      }
    }
  }
}

// 移动端适配样式
@media (max-width: 768px) {
  .subcontent {
    .pics {
      width: 100%;
      ul{
        margin:0;
        li{
          width: 50%;
          padding:0 5px;
        }
      }
    }
  }
}
</style>